import { render, staticRenderFns } from "./FacilityPerformanceControl.vue?vue&type=template&id=6169eff7"
import script from "./FacilityPerformanceControl.vue?vue&type=script&lang=js"
export * from "./FacilityPerformanceControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports